module.exports = __webpack_public_path__ + "static/media/feat-curtains-hero.205bd863.jpg";